module.exports = __webpack_public_path__ + "static/media/change_01.7d99e62c.jpg";